<template>
  <div class="collapsible-section" :class="{ 'is-open': isOpen }">
    <div class="collapsible-section__header" @click="toggle">
      <span class="collapsible-section__title"><lang :labelKey="title"></lang></span>
      <span class="collapsible-section__icon material-symbols-outlined">
        {{ isOpen ? 'expand_less' : 'expand_more' }}
      </span>
    </div>
    <transition name="section-toggle">
      <div v-show="isOpen" class="collapsible-section__body">
        <slot></slot>
      </div>
    </transition>
  </div>
</template>

<script>
export default {
  name: 'CollapsibleSection',

  props: {
    title: {
      type: String,
      required: true
    },
    defaultOpen: {
      type: Boolean,
      default: false
    }
  },

  data() {
    return {
      isOpen: this.defaultOpen
    }
  },

  methods: {
    toggle() {
      this.isOpen = !this.isOpen;
    }
  }
}
</script>

<style scoped lang="scss">
.collapsible-section {
  margin-bottom: 8px;
  border: 1px solid #e0e0e0;
  border-radius: 3px;
  background: #fff;
  overflow: visible;

  &.is-open {
    .collapsible-section__header {
      border-bottom: 1px solid #e0e0e0;
    }
  }
}

.collapsible-section__header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 10px 14px;
  cursor: pointer;
  background-color: #f5f7f9;
  user-select: none;
  transition: background-color 0.2s ease;
  border-bottom: 1px solid transparent;

  &:hover {
    background-color: #ebeef2;
  }
}

.collapsible-section__title {
  font-size: 12px;
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 0.03em;
  color: #475465;
}

.collapsible-section__icon {
  font-size: 20px;
  color: #888;
  transition: transform 0.25s ease;
}

.collapsible-section__body {
  padding: 16px 14px;
  overflow: visible;
}

/* transition */
.section-toggle-enter-active {
  animation: sectionExpand 0.25s ease-out;
}

.section-toggle-leave-active {
  animation: sectionExpand 0.2s ease-in reverse;
}

@keyframes sectionExpand {
  from {
    opacity: 0;
    transform: translateY(-8px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}
</style>
